import Vue from "vue";
import Router from "vue-router";
import i18n from "./i18n";
import { SUPPORTED_LOCALES } from "./utils/locales";
import { LIST_TOOLS } from "./utils/listTools";

Vue.use(Router);

const localePattern = SUPPORTED_LOCALES.join("|");

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      redirect: `/${i18n.locale}`,
    },

    {
      path: `/:lang(${localePattern})`,
      caseSensitive: true,
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        ...LIST_TOOLS.filter(tool => tool.path).map(tool => ({
          path: tool.path,
          name: `tool-${tool.id}`,
          component: () => import("./views/Home.vue"),
          meta: { toolId: tool.id },
        })),
        {
          path: "/",
          name: "home",
          component: () => import("./views/Home.vue"),
        },

        {
          path: "list/:id",
          name: "list",
          component: () => import("./views/ListPage.vue"),
        },

        {
          path: "privacy-policy",
          name: "privacy",
          component: () => import("./views/privacy.vue"),
        },
        {
          path: "legal-notice",
          name: "legal",
          component: () => import("./views/legal.vue"),
        },
        {
          path: "faq",
          name: "faq",
          component: () => import("./views/faq.vue"),
        },
        {
          path: "feedback",
          name: "feedback",
          component: () => import("./views/feedback.vue"),
        },
        {
          path: "*",
          name: "localized-not-found",
          component: () => import("./views/NotFound.vue"),
        },
      ],
    },
    {
      path: "*",
      name: "not-found",
      component: () => import("./views/NotFound.vue"),
    },
  ],
});
